var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"text-center text-404"},[_vm._v("404")]),_c('h3',{staticClass:"text-center text-404-description"},[_vm._v(" Sahifa topilmadi ")]),_c('div',{staticClass:"d-flex justify-center mt-16"},[_c('div',[_c('d-button',{attrs:{"width":"200px"},on:{"click":_vm.check_user}},[_vm._v("Qayta tekshirish")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }